<template>
  <div class="main-container">
    <div class="main-container-title-box">
      <div class="d-flex justify-center align-center">
        <div class="container-main-header-button">
          <v-btn depressed @click="back">
            <v-icon>mdi-chevron-left</v-icon>
          </v-btn>
          <span>Настройки раздела</span>
        </div>
        <div></div>
      </div>
      <v-btn
        @click="goToEdit"
        style="width: auto !important"
        class="button-action-blue"
      >
        Редактировать
      </v-btn>
    </div>
    <div
      class="d-flex align-center main-container-info-box"
      style="margin: 0 24px 40px 24px"
    >
      <v-switch
        v-model="reception.isHidden"
        @change="showInApp"
        hide-details
        color="var(--app-green-1)"
      ></v-switch>
      <span>Отображать раздел</span>
    </div>

    <div class="main-container-info-box">
      <div class="info-block">
        <div class="info-block-title">Описание</div>
        <div class="info-block-text">
          {{ reception.description }}
        </div>
      </div>

      <div class="info-block image-container">
        <div class="info-block-title">Изображение</div>
        <v-simple-table>
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">Формат</th>
                <th class="text-left">Место отображенния</th>
                <th class="text-left">Для смартфонов</th>
                <th class="text-left">Для планшетов</th>
              </tr>
            </thead>
            <tbody>
              <tr style="height: 60px">
                <td class="text-left">Иконка раздела</td>
                <td class="text-left">Изображение на фоне раздела</td>
                <td class="text-left">
                  <img
                    @click="openDialogImg(reception.smartphoneImage)"
                    v-if="reception.smartphoneImage"
                    class="table-img"
                    :src="reception.smartphoneImage"
                  />
                </td>
                <td class="text-left">
                  <img
                    @click="openDialogImg(reception.tabletImage)"
                    v-if="reception.tabletImage"
                    class="table-img"
                    :src="reception.tabletImage"
                  />
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </div>
      <div class="info-block image-container">
        <div class="info-block-title">Реакции раздела</div>
        <v-simple-table>
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">ID</th>
                <th class="text-left">Иконка</th>
                <th class="text-right">Название</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(item, index) in reactionsList"
                :key="index"
                style="height: 60px"
              >
                <td class="text-left">{{ item.id }}</td>
                <td class="text-left">
                  <img
                    @click="openDialogImg(item.imagePath)"
                    v-if="item.imagePath"
                    class="table-img"
                    :src="item.imagePath"
                  />
                </td>
                <td class="text-right">{{ item.name }}</td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data: () => ({
    showInfo: false,
    x: null,
    y: null,
    reception: {},
    files: [],
    imageWidth: 0,
    newImage: null,

    reactionsList: [],

    stubIcon: require("@/assets/phone.png"),

    showBlock: false,

    photo: {
      image: null,
      imageMobile: null,
      imageTablet: null,
    },
  }),
  methods: {
    goToEdit() {
      this.$emit("goToPage", "EditReception");
    },

    back() {
      this.$emit("goToPage", "DetailReception");
    },

    getReception() {
      const params = new URLSearchParams({
        receptionOfCandidateId: localStorage.getItem("electionId"),
      });
      this.$axios
        .get(
          this.$store.getters.apiAdminPanelV5 +
            `/ksa-election-blocks/reception-of-candidate-block?${params}`,
          {
            headers: {
              authorization: this.$store.getters.adminPanelHeaderAuth,
              "secret-key": this.$store.state.secretKeyCookie,
            },
          }
        )
        .then((res) => {
          this.reception = res.data;
          this.reception.isHidden = !this.reception.isHidden;
        })
        .catch((err) => {
          this.$store.commit("errorSet", true);
          this.$store.commit("errorTextSet", err);
        });
    },
    getReactions() {
      this.$axios
        .get(
          this.$store.getters.apiAdminPanelV5 +
            `/reception-of-candidates-reactions/list`,
          {
            headers: {
              authorization: this.$store.getters.adminPanelHeaderAuth,
              "secret-key": this.$store.state.secretKeyCookie,
            },
          }
        )
        .then((res) => {
          this.reactionsList = res.data;
        })
        .catch((err) => {
          this.$store.commit("errorSet", true);
          this.$store.commit("errorTextSet", err);
        });
    },
    showInApp() {
      this.$axios
        .patch(
          this.$store.getters.apiAdminPanelV5 +
            `/reception-of-candidates-blocks`,
          {
            receptionOfCandidatesId: localStorage.getItem("electionId"),
            isHidden: !this.reception.isHidden,
            originalImage: this.reception.originalImage,
            smartphoneImage: this.reception.smartphoneImage,
            tabletImage: this.reception.tabletImage,
            description: this.reception.description,
          },
          {
            headers: {
              authorization: this.$store.getters.adminPanelHeaderAuth,
              "secret-key": this.$store.state.secretKeyCookie,
            },
          }
        )
        .then(() => {
          this.getReception();
          this.$store.commit("errorSet", {
            key: true,
            text: "Статус успешно изменен",
            type: "success",
          });
        })
        .catch((err) => {
          this.$store.commit("errorSet", true);
          this.$store.commit("errorTextSet", err);
        });
    },
  },
  created() {
    this.getReception();
    this.getReactions();
  },
};
</script>
<style lang="scss" scoped>
.main-container {
  .main-container-title-box {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 40px 24px;

    .container-main-header-button {
      display: flex;
      align-items: center;

      span {
        font-size: 28px;
        font-weight: 400;
        margin-left: 16px;
      }
    }

    .main-container-title-box-text {
      display: flex;
      align-items: center;

      span {
        font-size: 28px;
        font-weight: 400;
        margin-right: 20px;
      }
    }
  }

  .main-container-info-box {
    .table-title {
      font-size: 24px;
      font-weight: 600;
      margin: 0 24px;
    }

    .info-block {
      width: 50%;
      margin: 0 24px;
      margin-bottom: 50px;

      .info-block-title {
        font-size: 24px;
        font-weight: 600;
      }

      .container-box-text {
        font-weight: 400;
        font-size: 14px;
        line-height: 24px;
        color: var(--app-dark-grey-1);
        margin-bottom: 16px;
      }

      .info-block-text {
        font-size: 18px;
        font-weight: 400;
        overflow-wrap: anywhere;
      }
    }

    .image-container {
      width: 96%;
      margin: 0 24px;
      margin-bottom: 50px;
    }

    .table-img {
      cursor: pointer;
      height: 38px;
      object-fit: contain;
    }
  }
}
</style>
